import styled from "@emotion/styled";
import PropTypes from "prop-types";

import ListItemButton from "@mui/material/ListItemButton";
import Box from "@mui/material/Box";
import CheckCircle from "@/assets/CheckCircle";

const CustomListButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: "10px",
  outline: `1px solid #C0C4CF`,
  alignItems: "flex-start !important",
  "& .layout_check_mark": {
    display: "none",
  },
  "&.Mui-selected": {
    outline: `2px solid ${theme.palette.secondary.main}`,
    "& .layout_check_mark": {
      display: "block",
    },
    "& .layout_hide_on_selected": {
      display: "none",
    },
  },
  "&:hover": {
    outline: `2px solid ${theme.palette.secondary.main}`,
  },

  "&.Mui-selected svg *[fill='#656B77']": {
    fill: `${theme.palette.primary.main}`,
    zIndex: -1,
  },
}));

const SelectListButton = ({ children, hideCheck, ...restOfProps }) => {
  return (
    <CustomListButton className="w-full h-full flex flex-col" {...restOfProps}>
      {children}
      {restOfProps.selected && !hideCheck && (
        <Box
          sx={{
            position: "absolute",
            right: "12px",
            top: "12px",
            zIndex: 100,
          }}
        >
          <CheckCircle />
        </Box>
      )}
    </CustomListButton>
  );
};

SelectListButton.propTypes = {
  children: PropTypes.node,
  hideCheck: PropTypes.bool,
};
export default SelectListButton;
